import { Stack } from '@mui/material';
import { WithdrawalFee } from './WithdrawalFee';
import { WithdrawalTime } from './WithdrawalTime';

interface IWithdrawalSummaryProps {
  amount: number;
}

const SHOW_WITHDRAWAL_FEE = false;

export function WithdrawalSummary({
  amount,
}: IWithdrawalSummaryProps): React.JSX.Element {
  return (
    <Stack gap={1.5}>
      {SHOW_WITHDRAWAL_FEE && <WithdrawalFee amount={amount} />}

      <WithdrawalTime />
    </Stack>
  );
}
